import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';
import { Link, withPrefix } from 'gatsby';

import { HTMLContent } from '~components/Content';
import { TableRow, TableData } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function AbsenteeMailBallotIssuesRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  const absenteeBallotIssues = stateData.absentee_ballot_issues
    ? stateData.absentee_ballot_issues.html
    : 'N/A';

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Backup voting options',
            valueNode: (
              <div>
                <HTMLContent content={absenteeBallotIssues} />
              </div>
            ),
          },
          {
            title: 'Where to vote',
            valueNode: (
              <Link
                to={withPrefix(`/where-to-vote/`)}
                title={`Where to vote in ${stateName}`}
              >
                Where to vote in {stateName}
              </Link>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

AbsenteeMailBallotIssuesRowRenderer.propTypes = rowRendererProps;
